import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/applicant/ApplicantHeader.module.css";
import backgroundImage from "../../assets/image/bg2.png";
import profileIcon from "../../assets/image/profile-icon2.png";
import settingsIcon from "../../assets/image/settings-icon.png";
import ApplicantProfile from "./ApplicantProfile";
import ApplicantZoneForm from "./ApplicantZoneForm";
import ApplicantPartPlanForm from "./ApplicantPartPlanForm";
import ChangePasswordPopup from "./ChangePasswordPopup";
//import emblem from '../../assets/image/emblem.png';

import emblem from '../../assets/image/logo1.png';

import SangliLogo from '../../assets/image/logo1.png';
import { currentLanguage } from '../../services/LanguageTranslationService';
import userGuide from '../../assets/documents/DP_Part Plan_SMKMC.pdf';

const ApplicantHeader = () => {
    const navigate = useNavigate();
    const [state, setState] = useState({
        showChangePassword: false,
        activeForm: null,
        isProfileVisible: false,
        applicantName: "Applicant",
        showSettingsDropdown: false,
        buttonPulse: true // New state for button animation
    });
    const dropdownRef = useRef(null);
    const token = localStorage.getItem("token");


    // Add blinking animation effect
    useEffect(() => {
        const interval = setInterval(() => {
            setState(prev => ({ ...prev, buttonPulse: !prev.buttonPulse }));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Memoized fetch function
    const fetchApplicantName = useCallback(async () => {
        try {
            {/* 
            const response_old = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get_applicant_fullname.php`,
                { credentials: "include" }
            );
            */}
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_applicant_fullname.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                //body: formData, // Make sure `formData` is a valid FormData object
                credentials: 'include'
            });
            const { full_name } = await response.json();
            setState(prev => ({ ...prev, applicantName: full_name }));
        } catch (error) {
            console.error("Failed to fetch applicant name:", error);
        }
    }, []);

    useEffect(() => {
        fetchApplicantName();
    }, [fetchApplicantName]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setState(prev => ({ ...prev, showSettingsDropdown: false }));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleChangePassword = useCallback(async (currentPassword, newPassword) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/change_applicant_password.php`,
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ currentPassword, newPassword }),
                }
            );
            const result = await response.json();

            if (result.status !== "success") {
                throw new Error(result.message || "Failed to change password");
            } else {
                window.location.href = "https://rppartplan.maharashtra.gov.in/client/build/";
            }
        } catch (error) {
            throw error;
        }
    }, []);

    const handleLogout = useCallback(async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/logout.php`,
                { method: 'POST', credentials: "include" }
            );
            const result = await response.json();
            if (result.status === "success") {
                setTimeout(() => result.redirect && navigate(result.redirect), 1500);
            } else {
                throw new Error(result.message || "Please try again.");
            }
        } catch (error) {
            console.error("Failed to logout:", error);
        }
    }, [navigate]);

    const handleFormOpen = useCallback((formType) => {
        setState(prev => ({ ...prev, activeForm: formType, buttonPulse: false }));
    }, []);

    const handleFormClose = useCallback(() => {
        setState(prev => ({ ...prev, activeForm: null }));
    }, []);

    const handleProfileOpen = useCallback(() => {
        setState(prev => ({ ...prev, isProfileVisible: true }));
    }, []);

    const handleProfileClose = useCallback(() => {
        setState(prev => ({ ...prev, isProfileVisible: false }));
    }, []);

    const toggleSettingsDropdown = useCallback(() => {
        setState(prev => ({ ...prev, showSettingsDropdown: !prev.showSettingsDropdown }));
    }, []);

    const handleSettingsOption = useCallback((option) => {
        setState(prev => ({ ...prev, showSettingsDropdown: false }));

        switch (option) {
            case 'Logout':
                handleLogout();
                break;
            case 'ChangePassword':
                setState(prev => ({ ...prev, showChangePassword: true }));
                break;
            default:
                console.log(`Selected option: ${option}`);
        }
    }, [handleLogout]);

    const {
        showChangePassword,
        activeForm,
        isProfileVisible,
        applicantName,
        showSettingsDropdown,
        buttonPulse
    } = state;

    return (
        <div className={styles.headerContainer}>
            <img
                src={backgroundImage}
                alt="Header background"
                className={styles.backgroundImage}
            />



            <div className={styles.settingsContainer} ref={dropdownRef}>
                <button
                    className={styles.settingsButton}
                    onClick={toggleSettingsDropdown}
                    aria-label="Settings"
                >
                    <img src={settingsIcon} alt="Settings" className={styles.settingsIcon} />
                </button>Settings
                {showSettingsDropdown && (
                    <div className={styles.settingsDropdown}>
                        <button onClick={() => handleSettingsOption('Logout')}>Logout</button>
                        <button onClick={() => handleSettingsOption('ChangePassword')}>Change Password</button>
                        <button onClick={() => handleSettingsOption('ResetPreview')}>Reset Preview</button>
                        <a href={userGuide} download="userguide.pdf">
                            <button onClick={() => handleSettingsOption('UserManual')}>User Manual</button>
                        </a>
                        {/* <button onClick={() => handleSettingsOption('UserManual')}>User Manual</button> */}
                    </div>
                )}
            </div>

            {/* 
            <img
                src={portalLogo}
                alt="Portal logo"
                className={styles.topleftImage}
            />
*/}
            <div className={styles.topleftImage} >
                <div className={styles.profileSection}>
                    <img
                        onClick={handleProfileOpen}
                        src={profileIcon}
                        alt="Profile"
                        className={styles.profileIcon}
                    />
                    <div className={styles.applicantName}>{applicantName}</div>
                </div>
            </div>


            <div className={styles.centerContent}>

                <div className={styles.clogobox}>
                    <div className={styles.clogo}>
                     <img src={emblem} alt="Government Emblem" className={styles.cemblem} /> 
                        <div className={styles.ctitlecontainer}>

                            <h1>
                                {currentLanguage === 'en'
                                    ? 'Part Plan And Zone Certificate Portal'
                                    : 'भाग योजना आणि क्षेत्र प्रमाणपत्र पोर्टल'}
                            </h1>

                            {/* 
                            <img
                                src={TPlogo}
                                alt="Overlay Image"
                                className={styles.overlayImageTPlogo}
                            />
                            */}


                            <p className={styles.csubtitle}>
                                {currentLanguage === 'en'
                                    ? 'Sangli, Miraj and Kupwad Municipal Corporation'
                                    : 'महाराष्ट्र शासन'}
                            </p>
                            <p className={styles.csubSubtitle}>
                                {currentLanguage === 'en'
                                    ? 'Town Planning Department'
                                    : 'नगर रचना आणि मूल्यांकन विभाग'}
                            </p>


                        </div>
                        {/* <img src={SangliLogo} alt="Government Emblem" className={styles.cemblem} /> */}
                    </div>
                </div>

                <br />
                {/*  <h2> Online Part Plan & Zone Certificate Portal </h2> */}

                <div className={styles.applyHereText}>
                    {currentLanguage === 'en'
                        ? 'Click here to apply 👇'
                        : 'अर्ज करण्यासाठी येथे क्लिक करा 👇'}
                </div>

                <div className={styles.buttonGroup}>
                    <button
                        className={`${styles.primaryButton} ${buttonPulse ? styles.pulseAnimation : ''}`}
                        onClick={() => handleFormOpen("partPlan")}
                    >
                        {currentLanguage === 'en'
                            ? 'Get Part Plan 👈'
                            : 'भाग योजना मिळवा 👈'}
                    </button>

                    <button
                        className={`${styles.secondaryButton} ${buttonPulse ? styles.pulseAnimation : ''}`}
                        onClick={() => handleFormOpen("zone")}
                    >
                        {currentLanguage === 'en'
                            ? 'Get Zone Certificate 👈'
                            : 'झोन प्रमाणपत्र मिळवा 👈'}
                    </button>

                </div>
            </div>

            {activeForm === "zone" && <ApplicantZoneForm closeForm={handleFormClose} />}
            {activeForm === "partPlan" && <ApplicantPartPlanForm closeForm={handleFormClose} />}
            {isProfileVisible && <ApplicantProfile onClose={handleProfileClose} />}
            {showChangePassword && (
                <ChangePasswordPopup
                    onClose={() => setState(prev => ({ ...prev, showChangePassword: false }))}
                    onSubmit={handleChangePassword}
                />
            )}
        </div>
    );
};

export default React.memo(ApplicantHeader);